import VectorSource  from "ol/source/Vector";
import { GeoJSON } from "ol/format";
function vector() {
    return new VectorSource({
        format: new GeoJSON(),
        url: `${window.localStorage.GISPolygonUrl}/query?outFields=*&spatialRel=esriSpatialRelIntersects&where=Network_ID=%274N1%27&f=geojson`,
        maxZoom: 15,
        projection: 'EPSG:4326',
        tileSize: 512,
        maxResolution: 180 / 512,
        wrapX: true,
    });
}

export function vectorObject({ features }) {
    const vectorsource = new VectorSource()
    vectorsource.addFeatures(features)
    return vectorsource
}

export function vectorObjectForPoint( features ) {
    // Filter out null/undefined features to prevent OpenLayers errors
    const validFeatures = features.filter(feature => feature !== null && feature !== undefined);
    const vectorsource = new VectorSource({
        features: validFeatures
    })
    return vectorsource
}

export default vector